export const FLAGS = {
  SCOUT_AGENT: 'SCOUT_AGENT',
  ENRICH_CONTACTS: 'ENRICH_CONTACTS',
  INTEGRATIONS: 'INTEGRATIONS',
} as const;

export type FeatureFlagKey = keyof typeof FLAGS;
